

var escape = module.exports = function escape(string) {
  return string.replace(/([&"<>'])/g, function(str, item) {
            return escape.map[item];
          })
}

var map = escape.map = {
    '>': '&gt;'
  , '<': '&lt;'
  , "'": '&apos;'
  , '"': '&quot;'
  , '&': '&amp;'
}


//////////////////
// WEBPACK FOOTER
// ./~/xml-escape/index.js
// module id = 1929
// module chunks = 0